import { render, staticRenderFns } from "./ManageAssignment.vue?vue&type=template&id=25d59e13"
import script from "./ManageAssignment.vue?vue&type=script&lang=js"
export * from "./ManageAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports